
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
/* eslint-disable prefer-destructuring */
/* eslint-disable no-sequences */
/* eslint-disable react/prop-types */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable default-case */
import MainLayout from 'global/MainLayout';
import useProtectedRoute from 'hooks/useProtectedRoute';
import {
  getUnboxingDetail,
  getModules,
  getChapterLessons,
} from 'lib/api/academy';
import SEO from 'global/SEO';
import { getYoutubeVideoId } from 'utils/stream';
import { STOCKBIT_ACADEMY_URL } from 'constants/api';
import { isMobile } from 'utils/serverside';
import { escape } from 'querystring';
import dynamic from 'next/dynamic';
import { trimText } from 'utils/general';

const Academy = dynamic(() => import('features/academy'), { ssr: false });
const PageLoader = dynamic(() => import('global/Loading/PageLoader'), {
  ssr: false,
});

function AcademyPage(props) {
  const { isLoaded } = useProtectedRoute();
  const { head } = props;

  return (
    <MainLayout isFlexibleWidth background="white">
      <SEO
        description={head.description || undefined}
        image={head.image || undefined}
        title={head.title || 'Stockbit Academy'}
      />
      <PageLoader loaded={isLoaded} />
      <Academy />
    </MainLayout>
  );
}

export async function getServerSideProps(context) {
  const {
    query: { slugs = [], ...restQuery },
    req: { headers, url },
  } = context;
  const { token = '', theme = 'light', source: sourceQuery } = restQuery;
  const userAgent = headers['user-agent'];
  const isFromMobile = isMobile(userAgent);
  const sourceKey = escape(sourceQuery);
  const source = sourceKey !== 'undefined' ? sourceKey : 'deeplink';

  let info = null;

  const getMetaData = async (
    type: 'module' | 'chapter' | 'lesson' | 'unboxing',
    { moduleId, chapterId, lessonId, unboxingId }: any,
  ) => {
    if (type === 'module') {
      await getModules()
        .then((res) => res.json())
        .then((res) => {
          const moduleData = res.data?.find(
            (item) => item.id === Number(moduleId),
          );
          info = {
            description: moduleData.description,
            title: moduleData.title,
            image: moduleData.cover_img,
          };
        })
        .catch(() => {
          info = null;
        });
    } else if (type === 'chapter' || type === 'lesson') {
      await getChapterLessons(chapterId)
        .then((res) => res.json())
        .then((res) => {
          if (type === 'chapter') {
            const chapterData = res.data.chapter;
            info = {
              description: chapterData.description,
              title: chapterData.title,
              image: `https://img.youtube.com/vi/${getYoutubeVideoId(
                chapterData.video_link,
              )}/maxresdefault.jpg`,
            };
          } else {
            const chapterData = res.data;
            const lessonData = chapterData?.lessons?.find(
              (item) => item.id === Number(lessonId),
            );
            info = {
              description: lessonData.content,
              title: lessonData.title,
              image: `https://img.youtube.com/vi/${getYoutubeVideoId(
                chapterData.chapter.video_link,
              )}/maxresdefault.jpg`,
            };
          }
        })
        .catch(() => {
          info = null;
        });
    } else if (type === 'unboxing') {
      await getUnboxingDetail(unboxingId)
        .then((res) => res.json())
        .then((res) => {
          const unboxingData = res.data;
          info = {
            description: unboxingData.description,
            title: unboxingData.title,
            image: unboxingData.thumbnail_url,
          };
        })
        .catch(() => {
          info = null;
        });
    }
  };

  const query = {
    moduleId: undefined,
    chapterId: undefined,
    lessonId: undefined,
    unboxingId: undefined,
  };

  let type:
    | 'module'
    | 'chapter'
    | 'lesson'
    | 'unboxing'
    | 'quiz'
    | 'unboxingsaham'
    | 'exploremodule'
    | 'chapterlist'
    | 'lessonlist'
    | 'lastviewedmodule'
    | 'lastviewedchapter'
    | 'lastviewedlesson'
    | 'lessonpage'
    | 'lastviewedquiz'
    | null = null;

  const trimmedSlugs: string = slugs.join('/');

  // academy/modules/{moduleId}
  if (/modules\/\d+(?:)/i.test(trimmedSlugs)) {
    type = 'module';
    query.moduleId = slugs[1];

    // academy/modules/{moduleId}/chapters/{chapterId}
    if (/(?:)chapters\/\d+(?:)/i.test(trimmedSlugs)) {
      type = 'chapter';
      query.chapterId = slugs[3];

      // academy/modules/{moduleId}/chapters/{chapterId}/lessons/{lessonID}
      if (/(?:)lessons\/\d+(?:)/i.test(trimmedSlugs)) {
        type = 'lesson';
        query.lessonId = slugs[5];
      }

      // special case with lessonId as query param
      // academy/modules/{moduleId}/chapters/{chapterId}/lessons/?lessonId={lessonID}
      if (
        /(?:)lessons\/[?]lessonId=\d+(?:)/i.test(url) &&
        restQuery?.lessonId
      ) {
        type = 'lesson';
        query.lessonId = restQuery.lessonId;
      }

      if (/(?:)quiz(?:)/i.test(trimmedSlugs)) {
        type = 'quiz';
      }
    }
  }

  // /academy/unboxing
  if (/unboxing(?:)/i.test(trimmedSlugs)) {
    type = 'unboxing';

    // academy/unboxing/{unboxingId}
    if (/unboxing\/\d+/i.test(trimmedSlugs)) {
      query.unboxingId = slugs[1];
    }

    // academy/unboxing/volume/{unboxingId}
    if (/unboxing\/volume\/\d+/i.test(trimmedSlugs)) {
      query.unboxingId = slugs[2];
    }
  }

  // academy/unboxingsaham
  if (/unboxingsaham(?:)/i.test(trimmedSlugs)) {
    type = 'unboxingsaham';

    if (/unboxingsaham\/\d+/i.test(trimmedSlugs)) {
      query.unboxingId = slugs[1];
    }
  }

  // academy/exploremodule
  if (/exploremodule/i.test(trimmedSlugs)) {
    type = 'exploremodule';
  }

  // academy/chapterlist/{moduleId}
  if (/chapterlist\/\d+(?:)/i.test(trimmedSlugs)) {
    type = 'chapterlist';
    query.moduleId = slugs[1];
  }

  // academy/lessonlist/{moduleId}/{chapterId}
  if (/lessonlist\/\d+\/\d+(?:)/i.test(trimmedSlugs)) {
    type = 'lessonlist';
    query.moduleId = slugs[1];
    query.chapterId = slugs[2];
  }

  // academy/lastviewedmodule/{moduleId}
  if (/lastviewedmodule\/\d+/i.test(trimmedSlugs)) {
    type = 'lastviewedmodule';
    query.moduleId = slugs[1];
  }

  // academy/lastviewedchapter/{moduleId}/{chapterId}
  if (/lastviewedchapter\/\d+\/\d+/i.test(trimmedSlugs)) {
    type = 'lastviewedchapter';
    query.moduleId = slugs[1];
    query.chapterId = slugs[2];
  }

  // academy/lastviewedlesson/{moduleId}/{chapterId}/{lessonId}
  if (/lastviewedlesson\/\d+\/\d+\/\d+/i.test(trimmedSlugs)) {
    type = 'lastviewedlesson';
    query.moduleId = slugs[1];
    query.chapterId = slugs[2];
    query.lessonId = slugs[3];
  }

  // academy/lessonpage/{moduleId}/{chapterId}/{lessonId}
  if (/lessonpage\/\d+\/\d+\/\d+/i.test(trimmedSlugs)) {
    type = 'lessonpage';
    query.moduleId = slugs[1];
    query.chapterId = slugs[2];
    query.lessonId = slugs[3];
  }

  // academy/lastviewedquiz/{moduleId}/{chapterId}
  if (/lastviewedquiz\/\d+\/\d+/i.test(trimmedSlugs)) {
    type = 'lastviewedquiz';
    query.moduleId = slugs[1];
    query.chapterId = slugs[2];
  }

  const BASE_URL = isFromMobile ? STOCKBIT_ACADEMY_URL : '/academy';
  const queryString: any = isFromMobile ? { token, theme, source } : {};
  let redirectUrl = null;

  if (type === null && isFromMobile) {
    redirectUrl = '/';
  } else {
    switch (type) {
      case 'module':
        await getMetaData('module', { moduleId: query.moduleId });
        if (isFromMobile) {
          redirectUrl = `/modules/${query.moduleId}`;
          break;
        }
        break;
      case 'chapter':
        await getMetaData('chapter', { chapterId: query.chapterId });
        if (isFromMobile) {
          redirectUrl = `/modules/${query.moduleId}/chapters/${query.chapterId}`;
          break;
        }
        break;
      case 'lesson':
        await getMetaData('lesson', {
          chapterId: query.chapterId,
          lessonId: query.lessonId,
        });
        if (isFromMobile) {
          redirectUrl = `/modules/${query.moduleId}/chapters/${query.chapterId}/lessons`;
          queryString.lessonId = query.lessonId;
          break;
        }
        break;
      case 'quiz':
        if (isFromMobile) {
          // redirect to academy
          redirectUrl = `/modules/${query.moduleId}/chapters/${query.chapterId}/quiz`;
        }
        break;
      case 'unboxing':
        await getMetaData('unboxing', { unboxingId: query.unboxingId });
        if (query.unboxingId && isFromMobile) {
          redirectUrl = `/unboxing/${query.unboxingId}`;
        } else if (query.unboxingId && url?.startsWith('/unboxing')) {
          redirectUrl = `/unboxing/${query.unboxingId}`;
        } else if (isFromMobile && !query.unboxingId) {
          redirectUrl = '/unboxing';
        }
        break;
      case 'unboxingsaham':
        await getMetaData('unboxing', { unboxingId: query.unboxingId });
        if (query.unboxingId) {
          redirectUrl = `/unboxing/${query.unboxingId}`;
        } else {
          redirectUrl = '/unboxing';
        }
        break;
      case 'exploremodule':
        // redirect to academy
        redirectUrl = '/explore';
        break;
      case 'chapterlist':
      case 'lastviewedmodule':
        await getMetaData('module', { moduleId: query.moduleId });
        redirectUrl = `/modules/${query.moduleId}`;
        break;
      case 'lessonlist':
      case 'lastviewedchapter':
        await getMetaData('chapter', { chapterId: query.chapterId });
        redirectUrl = `/modules/${query.moduleId}/chapters/${query.chapterId}/lessons`;
        break;
      case 'lastviewedlesson':
      case 'lessonpage':
        await getMetaData('lesson', {
          chapterId: query.chapterId,
          lessonId: query.lessonId,
        });
        if (isFromMobile) {
          redirectUrl = `/modules/${query.moduleId}/chapters/${query.chapterId}/lessons/`;
          queryString.lessonId = query.lessonId;
          break;
        } else {
          redirectUrl = `/modules/${query.moduleId}/chapters/${query.chapterId}/lessons/${query.lessonId}`;
        }
        break;
      case 'lastviewedquiz':
        redirectUrl = `/modules/${query.moduleId}/chapters/${query.chapterId}/quiz/`;
        break;
    }
  }

  // Trim description
  if (info?.description) {
    info.description = trimText(info.description, 160);
  }

  const parsedQueryString = new URLSearchParams(queryString);

  const redirect =
    redirectUrl !== null
      ? {
          permanent: false,
          destination: `${BASE_URL}${redirectUrl}?${parsedQueryString.toString()}`,
        }
      : false;

  return {
    redirect,
    props: {
      head: {
        description: info?.description || null,
        title: info?.title || null,
        image: info?.image || null,
      },
    },
  };
}

export default AcademyPage;
